import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "@/firebase";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export const AdminForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (err) {
      if (err.code === "auth/user-not-found") {
        // Don't reveal whether account exists — show same success message
        setSent(true);
      } else {
        toast.error("Une erreur est survenue. Réessayez.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{ backgroundColor: "#EAE8E4", fontFamily: "'DM Sans', sans-serif" }}
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="text-xs font-medium tracking-[0.2em] text-slate-500 uppercase mb-2">Hafani MS</p>
          <h1
            className="text-4xl text-slate-900"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 500 }}
          >
            Mot de passe oublié
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200/60 px-8 py-8">
          {sent ? (
            <div className="text-center space-y-4">
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
                <svg className="w-6 h-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-slate-700 text-sm font-medium">Email envoyé</p>
              <p className="text-slate-500 text-xs leading-relaxed">
                Si un compte correspond à <span className="font-medium text-slate-700">{email}</span>, vous recevrez un lien pour réinitialiser votre mot de passe.
              </p>
              <Link to="/admin/login" className="inline-block mt-2 text-emerald-600 text-sm hover:text-emerald-700 transition-colors">
                ← Retour à la connexion
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <p className="text-slate-500 text-sm leading-relaxed">
                Entrez votre adresse email pour recevoir un lien de réinitialisation.
              </p>
              <div className="space-y-1.5">
                <label className="block text-xs font-medium tracking-wide text-slate-500 uppercase">
                  Adresse email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="admin@hafani-ms.com"
                  className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-slate-50 text-slate-900 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-500 transition-all"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 rounded-xl bg-emerald-600 text-white text-sm font-medium hover:bg-emerald-700 active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Envoi…" : "Envoyer le lien"}
              </button>
              <div className="text-center">
                <Link to="/admin/login" className="text-xs text-slate-400 hover:text-slate-600 transition-colors">
                  ← Retour à la connexion
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
